module.exports = __webpack_public_path__ + "media/images/power-9fb6e40b3d4a1a93946343b5f5bd9c4d.svg";